import { render } from "./RecipieForm.vue?vue&type=template&id=3497aaf0"
import script from "./RecipieForm.vue?vue&type=script&lang=js"
export * from "./RecipieForm.vue?vue&type=script&lang=js"

import "./RecipieForm.vue?vue&type=style&index=0&id=3497aaf0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__